import { useEffect, useRef } from "react";

const BottomModal = ({
  className,
  children,
  onClickOutside
}) => {
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside && onClickOutside();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClickOutside]);

  return (
    <div className={`bottom-modal${className ? " modal--" + className : ""}`}>
      <div className="bottom-modal__content" ref={ref}>
        {children}
      </div>
    </div>
  );
};

export default BottomModal;
